// src/components/ProtectedAdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ADMIN_UID = '3N1QaQpLuRfJXNPUypBXBE61V3F3';

function ProtectedAdminRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-white text-center mt-20">🔒 Sjekker tilgang …</div>;
  }

  if (!user || user.uid !== ADMIN_UID) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedAdminRoute;
